export default "/images/f82c2c7c04582bca33d84b215fb0a53d.avif";